import get from 'lodash/get';
import { API_RESULT } from './api';

const CLEAR_STATUS = 'modules/manageAuthStatus/CLEAR_STATUS';

const reducer = (state = 0, action) => {
  switch (action.type) {
    case CLEAR_STATUS:
      return 0;
    case API_RESULT:
      return get(action, 'payload.authStatus', 0);
    default:
      return state;
  }
};

export { reducer as default, CLEAR_STATUS };
